import { render, staticRenderFns } from "./VPCList.vue?vue&type=template&id=0d688d9e"
import script from "./VPCList.vue?vue&type=script&lang=js"
export * from "./VPCList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports